// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const BusyCounter = t.Number;

export const getDefaultState = () => 0;

export default BusyCounter;



// WEBPACK FOOTER //
// ./src/shared/state/busy-counter.js